export default "__VITE_ASSET__Bu9Qh2$z__"